import { render, staticRenderFns } from "./PollSelector.vue?vue&type=template&id=1ec12e0c&scoped=true&"
import script from "./PollSelector.vue?vue&type=script&lang=js&"
export * from "./PollSelector.vue?vue&type=script&lang=js&"
import style0 from "./PollSelector.vue?vue&type=style&index=0&id=1ec12e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec12e0c",
  null
  
)

export default component.exports